import React, { useState, useEffect } from "react";
import "./LevelSwitcher.css";

const LevelSwitcher = ({
  level,
  handleLevelChange,
  renderSolutionTabs,
  progress,
  demoMode,
  fromLearningPath,
  totalRelevantSolutions,
  userRole, // <--- add this
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const beginnerComplete = progress?.BEGINNER === true;
  const proComplete = progress?.PRO === true;
  const intermediateCompletedCount =
    progress?.INTERMEDIATE?.solutionIds?.length || 0;

  const intermediateComplete =
    totalRelevantSolutions > 0 &&
    intermediateCompletedCount >= totalRelevantSolutions;

  const intermediateFillPercent =
    totalRelevantSolutions === 0
      ? 0
      : Math.round((intermediateCompletedCount / totalRelevantSolutions) * 100);

  const normalizedLevel = level?.toLowerCase();
  const intermediateLocked =
    userRole === "FREE_USER" || userRole === "PAID_USER";

  return (
    <div className="level-switcher-wrapper">
      <button
        className={`slider-button ${
          normalizedLevel === "beginner" ? "active" : ""
        } ${beginnerComplete ? "level-complete" : ""}`}
        onClick={() => handleLevelChange("Beginner")}
      >
        Beginner
      </button>

      {!demoMode && !fromLearningPath && (
        <div className="intermediate-dropdown-wrapper">
          <div
            className="intermediate-progress-wrapper"
            style={{
              "--fill-percentage": `${intermediateFillPercent}%`,
            }}
          >
            <button
              className={`slider-button ${
                normalizedLevel === "intermediate" ? "active" : ""
              } ${intermediateComplete ? "intermediate-complete" : ""} ${
                intermediateLocked ? "locked" : ""
              }`}
              onClick={() => {
                if (!intermediateLocked) {
                  handleLevelChange("Intermediate");
                  setShowDropdown((prev) => !prev);
                }
              }}
              onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
              disabled={intermediateLocked}
            >
              {intermediateLocked ? "Intermediate 🔒" : "Intermediate ▾"}
            </button>
          </div>

          {normalizedLevel === "intermediate" &&
            showDropdown &&
            !intermediateLocked && (
              <div className="solution-dropdown">{renderSolutionTabs()}</div>
            )}
        </div>
      )}

      <button
        className={`slider-button ${
          normalizedLevel === "pro" ? "active" : ""
        } ${proComplete ? "level-complete" : ""}`}
        onClick={() => handleLevelChange("Pro")}
      >
        Pro
      </button>
    </div>
  );
};


export default LevelSwitcher;
